<template>
	<div class="multi-format-status">
		<div
			v-if="currentUiStatus === UI_STATUS.RECORDING"
			class="multi-format-status__timer"
		>
			<div class="multi-format-status__timer-count">
				{{ remainingClipTimeSecsLeadingZero }}
			</div>
			<div class="multi-format-status__timer-label">
				{{ $I18n.trans_choice('commons.second', remainingClipTimeSecs) }}
			</div>
		</div>
		<div
			v-if="currentUiStatus === UI_STATUS.PREVIEW"
			class="multi-format-status__timer"
		>
			<div class="multi-format-status__timer-count">
				{{ previewCountdownLeadingZero }}
			</div>
			<div class="multi-format-status__timer-label">
				{{ $I18n.trans_choice('commons.second', previewCountdown) }}
			</div>
		</div>
		<div
			v-if="maxDurationReachedInfoVisible && currentUiStatus === UI_STATUS.FINISHED_RECORDING"
			class="multi-format-status__info"
		>
			{{ $I18n.trans('event.multiformat_editor.labels.30s_limit_reached') }}
		</div>
		<div
			v-if="currentUiStatus === UI_STATUS.READY"
			class="multi-format-status__info"
		>
			{{ $I18n.trans('event.multiformat_editor.labels.drag_to_start') }}
		</div>
	</div>
</template>

<script>
import { UI_STATUS } from './MultiFormatTool';

export default {
	name:  'MultiFormatStatus',
	props: {
		currentUiStatus: {
			type:     String,
			required: true,
		},
		maxDurationReachedInfoVisible: {
			type:    Boolean,
			default: false,
		},
		remainingClipTimeSecs: {
			type:    Number,
			default: 0,
		},
		remainingClipTimeSecsLeadingZero: {
			type:    String,
			default: '',
		},
		previewCountdown: {
			type:    Number,
			default: 0,
		},
		previewCountdownLeadingZero: {
			type:    String,
			default: '',
		},
	},
	data() {
		return {
			UI_STATUS,
		};
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.multi-format-status {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 76px;
}

.multi-format-status__info {
	display: flex;
	align-items: center;
	width: 100%;
	color: var(--color-soft-white);

	body.-t-light & { // stylelint-disable-line
		color: var(--color-black);
	}
}

.multi-format-status__timer {
	color: var(--color-grey-300);
	text-align: center;
}

.multi-format-status__timer-count {
	font-size: 32px; // stylelint-disable-line
	line-height: 1; // stylelint-disable-line
	font-weight: 600; // stylelint-disable-line
}

.multi-format-status__timer-label {
	padding-right: 0.2em;
}
</style>
